import {
  DeductionApplicationType,
  MoneyInput,
  WeightInput,
} from '@rematter/frontend-lib-api-client';

import { createMutationAtomFactory } from '~/shared/providers/api/createMutationAtomFactory';

export const loadDeductionUpdateAtom = createMutationAtomFactory(
  'trade.loadDeductionUpdate',
  (params: {
    id: string;
    deductionTypeId?: string | null;
    applicationType?: DeductionApplicationType | null;
    weightValue?: WeightInput | null;
    priceValue?: MoneyInput | null;
    percentage?: number | null;
    notes?: string | null;
  }) => {
    const input: Record<string, unknown> = {};
    if (params.deductionTypeId !== undefined)
      input.deductionTypeId = params.deductionTypeId;
    if (params.applicationType !== undefined)
      input.applicationType = params.applicationType;
    if (params.weightValue !== undefined)
      input.weightValue = params.weightValue;
    if (params.priceValue !== undefined) input.priceValue = params.priceValue;
    if (params.percentage !== undefined) input.percentage = params.percentage;
    if (params.notes !== undefined) input.notes = params.notes;

    return {
      tradeLoadDeductionUpdate: {
        __args: {
          id: params.id,
          input,
        },
        id: true,
        loadId: true,
        deductionTypeId: true,
        applicationType: true,
        weightValue: {
          value: true,
          unit: true,
        },
        priceValue: {
          amount: true,
          currencyCode: true,
        },
        calculatedAmount: {
          amount: true,
          currencyCode: true,
        },
        notes: true,
      },
    };
  },
);
